import { VueConstructor } from 'vue'

export interface AuthErrorEvent {
  content: VueConstructor | string
  onCloseModal?: () => void
}

export const nop = () => { /* no operation */ }
